import { Checkbox, FormControlLabel } from "@material-ui/core";
import React from "react";

const CheckboxField = ({ field, ...props }) => {
  return (
    <FormControlLabel
      style={{ display: "block" }}
      control={<Checkbox {...field} color="primary" />}
      label={props.label}
    />
  );
};

export default CheckboxField;
